import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import {
  DeviceBusTopologyProperties,
  Feature,
  FeatureNames,
  FeaturePropertyKey,
  IsNumberValueProperty,
  IsStringValueProperty,
  ProductIdentificationProperties,
} from '@vi-iot/client';

import { InstallationFeaturesStore, RichDevice } from '@store';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-control-units',
  templateUrl: './control-units.component.html',
  styleUrls: ['./control-units.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ControlUnitsComponent implements OnInit, OnDestroy {
  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  readonly featurePropertyKey = FeaturePropertyKey;
  busTopology$: Observable<Feature<DeviceBusTopologyProperties, never>>;
  memberId$: Observable<Feature<IsNumberValueProperty, never> | undefined>;
  deviceProductIdentification$: Observable<
    Feature<ProductIdentificationProperties, never> | undefined
  >;
  externalCANAddress: string;
  parameterIdentification$: Observable<Feature<IsStringValueProperty, never>>;

  @Input() cascadeDevice?: RichDevice;
  @Input() showExternalCANAddress: boolean;

  constructor(private installationFeaturesStore: InstallationFeaturesStore) {}

  ngOnInit(): void {
    if (this.cascadeDevice) {
      this.busTopology$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
        FeatureNames.deviceBusTopology,
        this.cascadeDevice.id
      );

      this.memberId$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
        FeatureNames.cascadeMemberId,
        this.cascadeDevice.id
      );

      this.deviceProductIdentification$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
        FeatureNames.deviceProductIdentification,
        this.cascadeDevice.id
      );

      this.parameterIdentification$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
        FeatureNames.deviceParameterIdentificationVersion,
        this.cascadeDevice.id
      );

      this.deviceProductIdentification$
        .pipe(takeUntil(this.ngUnsubscribe$))
        .subscribe((deviceProductIdentification) => {
          if (this.showExternalCANAddress) {
            const busAddress = deviceProductIdentification?.properties?.product?.value?.busAddress;
            const busType = deviceProductIdentification?.properties?.product?.value?.busType;
            this.externalCANAddress = busAddress && busType ? `${busType}/${busAddress}` : '';
          }
        });
    } else {
      this.busTopology$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
        FeatureNames.deviceBusTopology
      );
      this.parameterIdentification$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
        FeatureNames.deviceParameterIdentificationVersion
      );
    }
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
